import shortid from 'shortid'
import _ from 'lodash'
import {
  fetchJobList
} from '@pt/api/dmaker/job'
import {
  getGmakerJobList
} from '@pt/api/gmaker/job.js'

const downloadTask = {
  namespaced: true,

  state: {
    downloadTaskDialog: {
      visible: false
    },
    downloadConfirmDialog: {
      visible: false
    },
    taskList: [
      // {
      //   type: 'multi',
      //   status: 'pending',
      //   id: 0,
      //   job_type: '', // download、export、push
      //   progress_total: 0,
      //   progress_done: 0,
      //   download_url: ''
      // }
    ]
  },

  mutations: {
    updateDownloadTaskDialog: (state, value) => {
      state.downloadTaskDialog = {
        ...state.downloadTaskDialog,
        ...value
      }
    },
    updateDownloadTask: (state, value) => {
      state.taskList = value
    },
    updateDownloadConfirmDialog: (state, value) => {
      state.downloadConfirmDialog = value
    }
    // setPushIds: (state, value) => {
    //   state.pushIds = value
    // }
  },

  actions: {
    createDownloadTask({ commit, state }, task) {
      task.fe_id = shortid.generate()
      // state.
      const tasks = _.cloneDeep(state.taskList)
      tasks.push(task)

      commit('updateDownloadTask', tasks)
      commit('updateDownloadTaskDialog', {
        visible: true
      })
    },
    async fetchDownloadTask({ commit, state }, id) {
      const res = await fetchJobList()
      const gmakerRes = await getGmakerJobList()
      const list = _.get(res, 'data.data.list')
      const gmakerList = _.get(gmakerRes, 'data.data.list')
      const tempTasks = _.cloneDeep(state.taskList)
      commit('updateDownloadTask', tempTasks.map(item => {
        if (item.id) {
          const currentItem = list.find(el => el.id === item.id) || gmakerList.find(el => el.id === item.id)
          if ((item.status === 'running' || item.status === 'pending') && currentItem.status === 'completed') {
            window.open(
              JSON.parse(currentItem.result).download_url,
              '_blank'
            )
          }
          return {
            ...item,
            ...currentItem
          }
        }
        return item
      }))
    },
    cancelDownloadTask({ commit, state }, id) {
      if (id) {
        const temp = _.dropWhile(state.taskList, item => item.id === id || item.fe_id === id)
        commit('updateDownloadTask', temp)
        //
      } else {
        commit('updateDownloadTask', [])
      }
      // 清空task任务
    },
    showDownloadTaskDialog({ commit }) {
      commit('updateDownloadTaskDialog', {
        visible: true
      })
    },
    closeDownloadTaskDialog({ commit }) {
      commit('updateDownloadTaskDialog', {
        visible: false
      })
    },
    showDownloadConfirmDialog({ commit }) {
      commit('updateDownloadConfirmDialog', {
        visible: true
      })
    },
    closeDownloadConfirmDialog({ commit }) {
      commit('updateDownloadConfirmDialog', {
        visible: false
      })
    },
    resetDownloadTask({ commit }) {
      commit('updateDownloadTaskDialog', {
        visible: false
      })
      commit('updateDownloadConfirmDialog', {
        visible: false
      })
      commit('updateDownloadTask', [])
    }
  }
}

export default downloadTask
